module.exports = __webpack_public_path__ + "img/02_DISTRIBUCION_2.6163c522.jpg";